<div class="layout" id="layout"><div class="sidemenu-overlay" id="sidemenu-overlay" (click)="closeMenu()"></div><div class="page-container"><header_component></header_component><router-outlet></router-outlet><footer_component></footer_component></div></div><assistant></assistant>


// WEBPACK FOOTER //
// ./src/app/app.component.pug